import React from "react";
import {
    PlainModal,
    StandardModalFooter,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import styles from "./MigrationFinalizeWarningModal.module.scss";

interface MigrationFinalizeWarningModalProps {
    show?: boolean;
    warnings: string[];
    onCancel: () => void;
    onConfirm: () => void;
    isConfirming?: boolean;
    title?: string;
    description?: string;
    confirmLabel?: string;
}

export const MigrationFinalizeWarningModal: React.FC<
    MigrationFinalizeWarningModalProps
> = ({
    show,
    warnings,
    onCancel,
    onConfirm,
    isConfirming = false,
    title = "Complete migration with warnings?",
    description = "The uploaded data doesn't fully line up with the migration period:",
    confirmLabel = "Complete anyway",
}) => (
    <PlainModal show={show} onHide={onCancel} size="md">
        <StandardModalHeader>{title}</StandardModalHeader>
        <p>{description}</p>
        <ul className={styles.warnings}>
            {warnings.map((warning) => (
                <li key={warning}>{warning}</li>
            ))}
        </ul>
        <p>You can still complete the migration.</p>
        <StandardModalFooter className="mt-4">
            <Button
                type="button"
                variant="secondary"
                onClick={onCancel}
                size="xl"
                disabled={isConfirming}
            >
                Cancel
            </Button>
            <ButtonWithLoader
                variant="primary"
                type="button"
                loading={isConfirming}
                size="xl"
                onClick={onConfirm}
            >
                {confirmLabel}
            </ButtonWithLoader>
        </StandardModalFooter>
    </PlainModal>
);
